import { useEffect } from 'react';
import { Space } from 'antd';
import PropTypes from 'prop-types';
import EbzModal from 'components/EbzModal';
import payoutReportsAPI from 'services/payoutApi';
import InvoiceSummaryModal from './InvoiceSummaryModal';

function BulkInvoiceModal({
  pendingInvoiceIDs,
  invoiceSummaryModal,
  handleDrawerClose,
  payoutAcceptInvoice,
  toggleModal,
  setInvoiceSummaryLoading,
  invoiceSummaryLoading,
  invoiceSummary,
  setInvoiceSummary,
  yearMonth
}) {
  const fetchInvoiceSummary = async () => {
    setInvoiceSummaryLoading(true);
    const response = await payoutReportsAPI.PendingPayoutSummary({
      partner_payout_id: pendingInvoiceIDs,
      payout_month: yearMonth
    });

    if (!response.success) {
      console.log('something went wrong');
      setInvoiceSummaryLoading(false);
      return;
    }
    setInvoiceSummary(response?.data ?? []);
    setInvoiceSummaryLoading(false);
  };

  useEffect(() => {
    if (invoiceSummaryModal) fetchInvoiceSummary();
  }, [invoiceSummaryModal]);

  return (
    <EbzModal
      title="Upload Invoice"
      toggleModal={toggleModal}
      closable={false}
      width="65%"
      isOpen={invoiceSummaryModal}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <InvoiceSummaryModal
          invoiceSummary={invoiceSummary}
          invoiceSummaryLoading={invoiceSummaryLoading}
          payoutAcceptInvoice={payoutAcceptInvoice}
          setInvoiceSummaryLoading={setInvoiceSummaryLoading}
          handleDrawerClose={handleDrawerClose}
          selectedInvoice={pendingInvoiceIDs}
          yearMonth={yearMonth}
        />
      </Space>
    </EbzModal>
  );
}
BulkInvoiceModal.propTypes = {
  pendingInvoiceIDs: PropTypes.instanceOf(Array).isRequired,
  invoiceSummaryModal: PropTypes.bool.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  payoutAcceptInvoice: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  setInvoiceSummaryLoading: PropTypes.func.isRequired,
  invoiceSummaryLoading: PropTypes.bool.isRequired,
  invoiceSummary: PropTypes.instanceOf(Object).isRequired,
  setInvoiceSummary: PropTypes.func.isRequired,
  yearMonth: PropTypes.string.isRequired
};

export default BulkInvoiceModal;
